import { Card, CardActions, CardContent, CardHeader, Divider, Stack, Typography } from "@mui/material";
import { Box } from "@mui/system";

export const TilleyCard = ({ Avatar, title, subtitle, action, details, footer, customContent, ...props }) => {
  return (
    <Card className="farm-county-card" {...props}>
      <CardHeader
        avatar={
          <Box className="farm-county-card-avatar">
            <Avatar sx={{ width: "28px", height: "28px" }} />
          </Box>
        }
        title={
          <Typography variant="h6" data-testid={`card-title-${title}`}>
            {title}
          </Typography>
        }
        subheader={
          subtitle ? (
            <Typography variant="h5" data-testid={`card-subtitle-${subtitle}`}>
              {subtitle}
            </Typography>
          ) : null
        }
        action={action}
      />

      {(details || customContent) && <Divider />}

      <CardContent>
        {customContent ? (
          customContent
        ) : (
          <Stack direction="row" spacing={4} alignItems="center" justifyItems="center">
            {details?.map((detail, index) => (
              <Stack key={index} direction="column" spacing={1}>
                <Typography variant="subtitle2">{detail.value}</Typography>
                <Typography variant="overline">{detail.label}</Typography>
              </Stack>
            ))}
          </Stack>
        )}
      </CardContent>
      {footer && (
        <>
          <Divider />
          <CardActions>
            <Stack direction="row" spacing={0} sx={{ flexWrap: "wrap", rowGap: 1, columnGap: 2 }}>
              {footer}
            </Stack>
          </CardActions>
        </>
      )}
    </Card>
  );
};
